import { AxiosError, AxiosResponse } from 'axios';
import { GenericErrorResponse } from '../../..';
import { useCustomMutate } from '../../../../hooks/query';
import { postValidateAccessLink } from '../api-services/api';
import { ValidateAccessLinkRequest, ValidateAccessLinkResponse } from '../model';
import { POST_VALIDATE_ACCESS_LINK_KEY } from './keys';

export const usePostValidateAccessLink = (
  onSuccess: (res: AxiosResponse<ValidateAccessLinkResponse>) => void,
  onError: (err: AxiosError<GenericErrorResponse>) => void
) =>
  useCustomMutate<AxiosResponse<ValidateAccessLinkResponse>, ValidateAccessLinkRequest>(
    [POST_VALIDATE_ACCESS_LINK_KEY],
    (csrfToken, data) => postValidateAccessLink(csrfToken, data),
    {
      onSuccess,
      onError,
    },
    true,
    false
  );
